export default "__VITE_ASSET__DxXeK2XD__"